import { render } from "./generalInformation.vue?vue&type=template&id=5ceab94a"
import script from "./generalInformation.vue?vue&type=script&lang=js"
export * from "./generalInformation.vue?vue&type=script&lang=js"

import "./generalInformation.vue?vue&type=style&index=0&id=5ceab94a&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__